// Simple way to get the scrollable wrapper of an element without passing refs around.
export const getScrollableParent = (htmlElement: HTMLElement | null): HTMLElement | null => {
  if (htmlElement == null) {
    return null;
  }
  if (htmlElement.scrollHeight > htmlElement.clientHeight) {
    return htmlElement;
  } else {
    return getScrollableParent(htmlElement.parentElement);
  }
};

// Check if an element is visible inside the scrollable container and return the y offset if it's not.
export const getYOffsetOutsideOfVisibleScroll = (
  element: HTMLElement | null,
  scrollableContainer: HTMLElement | null,
) => {
  if (scrollableContainer && element) {
    const scrollYOffset = element.getBoundingClientRect().top - scrollableContainer.getBoundingClientRect().top;
    if (scrollYOffset < 0 || scrollYOffset > scrollableContainer.clientHeight) {
      return scrollYOffset;
    }
  }
  return false;
};

// Check if an element is visible inside the scrollable container and scroll it into view if it's not.
export const scrollElementIntoView = (element: HTMLElement | null, scrollableContainer: HTMLElement | null) => {
  if (scrollableContainer && element) {
    const scrollYOffset = getYOffsetOutsideOfVisibleScroll(element, scrollableContainer);
    if (!!scrollYOffset) scrollableContainer.scrollTo({ top: scrollableContainer.scrollTop + scrollYOffset });
  }
};
